// w550 version is default one
// w1100 is only used for images from video files

export default (image) => image?.url?.w550 || image?.url?.w1100;
